import { ActionTree, ActionContext } from 'vuex';

import { subsClient } from '@/http-client';
import { camelToSnake, snakeToCamel } from '@/utils';

import { RootStateI } from '../state';
import { ServicesStateI } from './state';

export const actions: ActionTree<ServicesStateI, RootStateI> = {
};
